module.exports = __webpack_public_path__ + "img/laboratorio_9-16.ce25bbd8.webp";